import script from "./DefLabels.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefLabels.vue?vue&type=script&lang=ts&setup=true"

import "./DefLabels.vue?vue&type=style&index=0&id=782009a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-782009a0"]])

export default __exports__